import { Constantes } from "../constants/constantsGlobal";
import { iResponse } from "../models/interfaceResponse";
import { iUserLoginRequest } from "../models/interfaceUserLogin";
import setupInterceptor from "./setupInterceptor";

export const userLoginDetailService = async ( 
    request: iUserLoginRequest,    
    user: any, 
    setUser: (user: any) => void
  ): Promise<iResponse> => {
    try {
        const response = await setupInterceptor(Constantes.URI_SecurityUserLogin, user,setUser, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body:  JSON.stringify(request),
        }); 
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      } 
      const data: iResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error al enviar datos:', error);
      throw error;
    }
  };